const MenuImages = {};
const Logo = require('../assets/images/logo.png')
const LoginBG = require('../assets/images/login-bg.jpg')
const Images = {
	MenuImages,
	Logo,
	LoginBG,
};

export default Images;